import { useQuery } from "@tanstack/react-query";
import { permissionsService } from "../../services/admin/permissions.service";

export function usePermissionsAdmin() {
  return useQuery({
    queryKey: ["admin", "permissions"],
    queryFn: permissionsService.getAll,
  });
}

export function usePermission(id?: string) {
  return useQuery({
    queryKey: ["admin", "permissions", id],
    queryFn: () => permissionsService.getById(id!),
    enabled: !!id,
  });
}
